<template>
  <div class="datepicker">
    <DatePickerMobile
       v-if="!onlyDesktop && isMobile"
      :value="value"
      :defaultDateToSet="defaultDateToSet_"
      :min-date="minDate"
      :max-date="maxDate"
      :placeholder="placeholder"
      :validation="validation"
      @input="$emit('input', $event)" >
      <template v-slot:invalid-input-error>
        <slot name="mobile-invalid-input-error">
          {{ $t('qic_error_invalid_input') }}
        </slot>
      </template>
    </DatePickerMobile>
    <DatePickerDesktop
      v-else
      :withInput="true"
      :value="value"
      :defaultDateToSet="defaultDateToSet_"
      :min-date="minDate"
      :max-date="maxDate"
      :placeholder="placeholder"
      :validation="validation"
      @input="$emit('input', $event)" />
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect'
import DatePickerDesktop from './DatePickerDesktop.vue'
import DatePickerMobile from './DatePickerMobile.vue'
export default {
  name: 'DatePicker',
  props: [
    'value',
    'placeholder',
    'minDate',
    'maxDate',
    'validation',
    'defaultDateToSet'
  ],
  components: {
    DatePickerDesktop,
    DatePickerMobile
  },
  data () {
    return {
      onlyDesktop: true
    }
  },
  computed: {
    isMobile () {
      return isMobile
    },
    defaultDateToSet_ () {
      return this.defaultDateToSet
    }
  }
}
</script>
